module.exports = __webpack_public_path__ + "static/scale-model-of-los-angeles-california-4e5730515416653f5200476c5d2f427a.png";